import { z } from 'zod';
import axios from '@/plugins/axios.js';

const ContextAccountUserPayloadSchema = z
    .object({
        id: z.number(),
        account_id: z.number(),
    })
    .passthrough();

const ContextAccountUsersResponseSchema = z.object({
    data: z.array(ContextAccountUserPayloadSchema),
});

export type ContextAccountUserPayload = z.infer<typeof ContextAccountUserPayloadSchema>;

export const fetchExactAccountUsers = async (
    accountId: number
): Promise<ContextAccountUserPayload[]> => {
    const response = await axios.get(`v1/context-account/${accountId}/users`);
    const { data: users } = ContextAccountUsersResponseSchema.parse(response.data);

    return users.filter((user) => user.account_id === accountId);
};
